import React, { lazy, Component, Suspense } from 'react';
import { Box, Container, Typography } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import { Helmet } from 'react-helmet-async';
// import LatestPosts from './LatestPost';
import { Link } from 'react-router-dom';
import fallbackImage from '../../assets/background.jpg';

import samplePosts from './samplePosts';

const LazyLatestPosts = lazy(() => import('./LatestPost'));

class BlogPost extends Component {
    state = {
        post: null,
        isLoading: false,
        notFound: false,
        latestPosts: [],
    };

    componentDidMount() {
        this.fetchPost();
        this.fetchLatestPosts();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.params?.id !== this.props.params?.id) {
            this.setState({ post: null, notFound: false, isLoading: false });
            this.fetchPost();
        }
    }

    fetchPost = async () => {
        const { params } = this.props;
        const postSlug = params.id;

        // Check if postSlug is defined
        if (!postSlug) {
            this.setState({ notFound: true, isLoading: false });
            return;
        }

        const fallback = samplePosts.find((post) => post.slug === postSlug);
        if (fallback) {
            this.setState({ post: fallback, isLoading: false });
            return;
        }
        this.props.history.push('/404');
        this.setState({ notFound: true, isLoading: false });
    };


    fetchLatestPosts = () => {
        const latestPosts = this.normalizePosts(samplePosts).slice(0, 3);
        this.setState({ latestPosts });
    };

    normalizePosts = (posts) => {
        if (!Array.isArray(posts)) {
            return [];
        }
        return posts.map((post, index) => ({
            ...post,
            id: post.id ?? index + 1,
            image: post.image || post.photo_link || '',
            short: post.short || post.summary || '',
        }));
    };

    normalizePost = (post) => {
        if (!post) {
            return null;
        }
        return {
            ...post,
            image: post.image || post.photo_link || '',
            short: post.short || post.summary || '',
        };
    };

    render() {
        const { post, notFound } = this.state;

        if (notFound) return <div>Post not found.</div>;

        return (
            <Container maxWidth='lg'>
                {/* Helmet component for managing head tags */}
                <Helmet>
                    <title>{post ? `${post.title} - Blog Robotics Media` : 'Blog Title'}</title>
                    <meta name="description" content={post ? post.summary : "Default blog description"} />
                    <meta name="keywords" content={post ? post.keywords : "default, keywords, blog"} />
                </Helmet>
                <Box sx={{ height: '150px' }} />
                <Box>
                    {post && (
                        <>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <Typography variant="h2" color='white' gutterBottom sx={{ fontFamily: 'Work Sans, sans-serif' }}>
                                    {post.title}
                                </Typography>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center', color: 'rgba(255,255,255,0.8)' }}>
                                    <Typography variant="body2" fontFamily='Pt Mono' fontSize='0.95rem'>
                                        Author: {post.author}
                                    </Typography>
                                    <Typography variant="body2" fontFamily='Pt Mono' fontSize='0.95rem'>
                                        {post.date_published ? new Date(post.date_published).toLocaleDateString(undefined, {
                                            year: 'numeric',
                                            month: 'long',
                                            day: 'numeric',
                                        }) : 'Invalid Date'}
                                    </Typography>
                                    <Link to={`/blog/${post.category}`} style={{ textDecoration: 'none' }}>
                                        <Box sx={{ border: '1px solid rgba(255,255,255,0.5)', borderRadius: '999px', px: 2, py: 0.5 }}>
                                            <Typography variant="body2" color="white" fontFamily='Pt Mono' fontSize='0.9rem'>
                                                {post.category}
                                            </Typography>
                                        </Box>
                                    </Link>
                                </Box>
                                {post.summary && (
                                    <Typography sx={{ color: 'rgba(255,255,255,0.85)', fontFamily: 'Work Sans, sans-serif', fontSize: '1.1rem', maxWidth: '900px' }}>
                                        {post.summary}
                                    </Typography>
                                )}
                                <Box sx={{ mt: 2, borderRadius: '24px', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.2)' }}>
                                    <img
                                        src={post.image || fallbackImage}
                                        alt={post.title}
                                        style={{ width: '100%', height: '420px', objectFit: 'cover', display: 'block' }}
                                        onError={(event) => { event.currentTarget.src = fallbackImage; }}
                                    />
                                </Box>
                            </Box>
                            <Box sx={{ mt: 4, color: 'white', fontFamily: 'Work Sans, sans-serif', lineHeight: 1.8 }}>
                                <ReactMarkdown>{post.content}</ReactMarkdown>
                            </Box>
                        </>
                    )}

                    <Suspense fallback={<div>Loading latest posts...</div>}>
                        <Box mt={4}>
                            <Typography variant="h5" color="white">Latest Posts</Typography>
                            <LazyLatestPosts latestPosts={this.state.latestPosts} />
                        </Box>
                    </Suspense>
                </Box>
            </Container>
        );
    }
}

export default BlogPost;
